export const Services = {
  "auth-service": {
    name: "Auth Service",
    label: "Služba pro získání JWT pro stavební řízení",
  },
  "document-service": {
    name: "Document service",
    label: "Služba pro práci s dokumenty",
  },
  "ext-contents-service": {
    name: "EXT content service",
    label: "Služba pro práci stahování / nahrávání dokumentů"
  },
  "file-service": {
    name: "File service",
    label: " Služba pro ovládání spisu a řízení"
  },
  "project-service":{
    name: "Project service",
    label: "Služba pro ovládání projektového záměru a jeho verzí"
  },
  "organization-service": {
    name: "Organization service",
    label: "Služba pro práci s organizacemi"
  }
}
export type ServiceKey = keyof typeof Services;